export default "__VITE_ASSET__a6957ed6__"